import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Table, Space, Empty, Tag } from 'antd'
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons'
import PageLoader from '../../../components/Layouts/PageLoader'
import PaginationContainer from '../../../components/Forms/Pagination'
import { getRequest, formatUrl, dutyPromotionsUrl } from '../../../config'
import { formatMoney } from '../../Analytics/utils'
import { promotionStatusTag } from './statusColors'

const PromotionList = props => {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
  const [meta, setMeta] = useState({ previous: null, next: null, count: 0 })

  const load = async (url = null) => {
    const response = await getRequest(
      url ? formatUrl(url) : dutyPromotionsUrl,
      'promotions',
      setLoading
    )
    if (response.success) {
      setRows(response.data.results || response.data)
      setMeta({ ...response.data })
    }
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line
  }, [])

  const fmtDate = v => (v ? new Date(v).toLocaleString() : '—')

  const columns = [
    {
      title: 'Name',
      key: 'name',
      render: (_, r) => <Link to={`/duty-assistant/promotions/${r.id}`}>{r.name}</Link>
    },
    {
      title: 'Discount',
      key: 'discount',
      render: (_, r) => (
        <span>
          {r.discountPercent}%
          {r.maxDiscountAmount ? (
            <span style={{ color: '#888' }}> (max {formatMoney(r.maxDiscountAmount, 'GHS')})</span>
          ) : null}
        </span>
      )
    },
    {
      title: 'Audience',
      key: 'audience',
      render: (_, r) =>
        r.appliesToDealers ? (
          <Tag color="purple">All incl. dealers</Tag>
        ) : (
          <Tag>Excludes dealers</Tag>
        )
    },
    { title: 'Starts', dataIndex: 'startAt', key: 'startAt', render: fmtDate },
    { title: 'Ends', dataIndex: 'endAt', key: 'endAt', render: fmtDate },
    { title: 'Status', key: 'status', render: (_, r) => promotionStatusTag(r) },
    {
      title: 'Redemptions',
      key: 'redemptions',
      render: (_, r) => (
        <span>
          {r.redemptionCount || 0}
          {r.paidRedemptionCount ? (
            <span style={{ color: '#888' }}> ({r.paidRedemptionCount} paid)</span>
          ) : null}
        </span>
      )
    }
  ]

  return (
    <PageLoader className="container" loading={loading}>
      <div className="card mb-5rem">
        <div className="card-body">
          <Space
            style={{ width: '100%', justifyContent: 'space-between', marginBottom: 8 }}
            wrap
          >
            <div>
              <h3 style={{ marginBottom: 4 }}>
                Promotions {meta && `(${meta.count || rows.length})`}
              </h3>
              <p style={{ color: '#888', margin: 0 }}>
                Time-boxed discounts off the duty <strong>service fee</strong>. The best running
                promotion is applied automatically to every estimate and charge.
              </p>
            </div>
            <Space>
              <Button icon={<ReloadOutlined />} onClick={() => load()}>
                Refresh
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => props.history.push('/duty-assistant/promotions/new')}
              >
                New promotion
              </Button>
            </Space>
          </Space>

          <Table
            rowKey="id"
            dataSource={rows}
            columns={columns}
            scroll={{ x: 900 }}
            pagination={false}
            locale={{ emptyText: <Empty description="No promotions yet" /> }}
          />
          {rows.length ? (
            <PaginationContainer meta={meta} getData={url => load(url)} />
          ) : null}
        </div>
      </div>
    </PageLoader>
  )
}

PromotionList.propTypes = {
  history: PropTypes.object
}

export default PromotionList
